import { DEFAULT_RRULE_DAYS_STATE } from "@/consts";
import type { RruleOptions } from "@/types";

export default (startDate?: number): RruleOptions => {
  return {
    startDate,
    cadence: 1,
    occurence: 1,
    days: { ...DEFAULT_RRULE_DAYS_STATE },
    repeatAmount: 1,
    dayOrder: undefined,
    daySelection: undefined,
    endingType: undefined,
  };
};
